import React from "react";
import { colors } from "../../../../../../themes/Colors";
import { BaseButtons, TextInputField } from "../../../../../common-components";

const UserPopUpDisplay = ({
  display,
  setUserPopUp,
  selectedAgent,
  setSelectedAgent,
}) => {
  return (
    <div
      style={{
        position: "absolute",
        bottom: 0,
        backgroundColor: colors.white,
        overflow: "hidden",
        height: display ? "100%" : 0,
        width: "100%",
        transition: "all 0.2s",
        display: "flex",
      }}
    >
      <div
        style={{
          top: 20,
          left: 20,
          position: "absolute",
          display: "flex",
          alignItems: "center",
        }}
      >
        <BaseButtons
          label={"BACK"}
          backgroundColor={colors.orangeDark}
          borderRadius={8}
          width={120}
          onClick={() => {
            setUserPopUp(false);
            setSelectedAgent(null);
          }}
        />
        <div style={{ marginLeft: 20, fontWeight: "bold", fontSize: 18 }}>
          AGENT INFORMATION
        </div>
      </div>
      <div style={{ flex: 1, display: "flex" }}>
        <div
          style={{
            flex: 0.5,
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <div style={{ minHeight: 80 }} />
          <TextInputField
            mini={true}
            labelTitle={"First name"}
            size={"85%"}
            value={selectedAgent ? selectedAgent.firstName : "loading"}
            readOnly={true}
          />
          <div style={{ minHeight: 5 }} />
          <TextInputField
            mini={true}
            labelTitle={"Last name"}
            size={"85%"}
            value={selectedAgent ? selectedAgent.lastName : "loading"}
            readOnly={true}
          />
          <div style={{ minHeight: 5 }} />
          <TextInputField
            mini={true}
            labelTitle={"cell number"}
            size={"85%"}
            value={selectedAgent ? selectedAgent.cellNumber : "loading"}
            readOnly={true}
          />
          <div style={{ minHeight: 5 }} />
          <TextInputField
            mini={true}
            labelTitle={"Email"}
            size={"85%"}
            value={selectedAgent ? selectedAgent.email : "loading"}
            readOnly={true}
          />
          <div style={{ minHeight: 5 }} />
          <TextInputField
            mini={true}
            labelTitle={"Account type"}
            size={"85%"}
            value={selectedAgent ? selectedAgent.type : "loading"}
            readOnly={true}
          />
          <div style={{ minHeight: 5 }} />
          <TextInputField
            mini={true}
            labelTitle={"Team"}
            size={"85%"}
            value={selectedAgent ? selectedAgent.Team : "loading"}
            readOnly={true}
          />
        </div>
        <div
          style={{
            flex: 0.5,
            display: "flex",
            flexDirection: "column",
            // borderStyle: "solid",
            height: "100%",
            alignItems: "center",
          }}
        >
          <div style={{ marginTop: 30, fontSize: 18, fontWeight: "bold" }}>
            TASK HISTORY
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserPopUpDisplay;
